import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaChevronLeft } from 'react-icons/fa';

import { BoldText, RegularText } from '../../components/common/Text';
import StyledTappable from '../../components/common/StyledTappable';
import ManipalLogo from '../../images/ManipalLogo.png';
import VisitLogo from '../../images/visitlogo.svg';
import HospitalService from '../../images/HospitalService.svg';
import EnterAppointmentDetails from '../../images/AppointmentDetails.svg';
import RecieveCashlessLetter from '../../images/RecieveCashlessLetter.svg';
import CompleteAppointment from '../../images/CompleteAppointment.svg';
import Pharmcy from '../../images/Pharmacy.png';
import ClinicAppointments from '../../images/ClinicAppointments.png';
import LabTests from '../../images/LabTests.png';
import { fetchCenterLogos } from '../../services/scanAndPay';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  background: #F7F4ED;
  overflow-y: auto;
  overflow-x: hidden;
`;

const Header = styled.div`
  position: relative;
  background: linear-gradient(180deg, #FADFBA -40.53%, #361797 7.39%, #391C94 48.16%, #2E1285 77.63%);
  border-radius: 0 0 40px 40px;
  padding: 40px 16px 24px;
  overflow: hidden;
  width: 100%;
  flex-shrink: 0;
  
  @media (min-width: 768px) {
    padding: 48px 24px 28px;
  }
  
  /* Purple shadow top right */
  &::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(138, 43, 226, 0.4) 0%, rgba(138, 43, 226, 0) 70%);
    border-radius: 50%;
  }
  
  /* Greenish shadow bottom left */
  &::after {
    content: '';
    position: absolute;
    bottom: -80px;
    left: -80px;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, rgba(0, 255, 200, 0.3) 0%, rgba(0, 255, 200, 0) 70%);
    border-radius: 50%;
  }
`;
const HeaderContent = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoContainer = styled.div`
  display: flex;
  width: 250px;
  height: 52px;
  padding: 6px 14px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 40px;
  background: #FFF;
  margin: 0 auto 12px auto;
  
  @media (min-width: 768px) {
    width: 250px;
    height: 52px;
  }
`;

const LogoImage = styled.img`
  height: 28px;
  max-width: 100%;
  width: auto;
  object-fit: contain;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  
  @media (min-width: 768px) {
    height: 32px;
  }
`;

const WelcomeText = styled.div`
  color: #FFF;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "Bricolage Grotesque";
  font-size: 31px;
  font-style: normal;
  font-weight: 800;
  line-height: 107%;
  margin: 0;
  margin-bottom: 12px;
  
  @media (min-width: 768px) {
    font-size: 31px;
  }
`;

const SubTitle = styled.div`
  font-size: 13px;
  margin: 0;
  font-style: italic;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
  
  .cashless {
    color: #FADFBA;
    font-family: Inter;
    font-size: 16px;
    font-style: italic;
    font-weight: 900;
    line-height: 150%;
  }
  
  .powered-by {
    color: #FFF;
    font-family: Inter;
    font-size: 16px;
    font-style: italic;
    font-weight: 500;
    line-height: 150%;
  }
  
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const VisitLogoImage = styled.img`
  width: 59.191px;
  height: 19.379px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
`;

const ContentSection = styled.div`
  padding: 20px 16px 80px 16px;
  background: #F7F4ED;
  
  @media (min-width: 768px) {
    padding: 24px 24px 80px 24px;
    max-width: 768px;
    margin: 0 auto;
    width: 100%;
  }
  
  @media (min-width: 1024px) {
    max-width: 900px;
  }
`;

const SectionTitle = styled.div`
  color: #000000;
  font-size: 20px;
  margin: 0 0 18px 0;
  font-weight: 700;
  
  @media (min-width: 768px) {
    font-size: 22px;
    margin: 0 0 20px 0;
  }
`;

const ServiceCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 24px;
  
  @media (min-width: 768px) {
    gap: 14px;
    margin-bottom: 28px;
  }
`;

const ServiceCard = styled.div`
  background: transparent;
  border-radius: 0;
  padding: 0;
  display: block;
  border: none;
  cursor: pointer;
  grid-column: ${props => props.isRectangular ? 'span 2' : 'span 1'};
  overflow: visible;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  
  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 0;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: optimize-contrast;
    pointer-events: none;
  }
  
  &:active {
    opacity: 0.8;
  }
`;

const ServiceImageContainer = styled.div`
  width: ${props => props.isRectangular ? '100px' : '100px'};
  height: ${props => props.isRectangular ? '80px' : '80px'};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: ${props => props.isRectangular ? 'relative' : 'absolute'};
  bottom: ${props => props.isRectangular ? 'auto' : '0'};
  right: ${props => props.isRectangular ? 'auto' : '0'};
  margin: 0;
  
  @media (min-width: 768px) {
    width: ${props => props.isRectangular ? '80px' : '85px'};
    height: ${props => props.isRectangular ? '80px' : '85px'};
    bottom: ${props => props.isRectangular ? 'auto' : '0'};
    right: ${props => props.isRectangular ? 'auto' : '0'};
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ServiceContent = styled.div`
  flex: ${props => props.isRectangular ? 'none' : '1'};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  z-index: 1;
  max-width: ${props => props.isRectangular ? 'calc(100% - 90px)' : '100%'};
  ${'' /* padding-right: ${props => props.isRectangular ? '0' : '85px'}; */}
  
  @media (min-width: 768px) {
    ${'' /* padding-right: ${props => props.isRectangular ? '0' : '95px'}; */}
  }
`;

const ServiceName = styled.div`
  color: #0F0B28;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
  line-height: 1.3;
  letter-spacing: -0.14px;
  white-space: nowrap;
  
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const ServiceDescription = styled.div`
  color: #9ca3af;
  font-size: 13px;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
  white-space: normal;
  
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const HowItWorksSection = styled.div``;

const HowItWorksTitle = styled.div`
  color: #000000;
  font-size: 20px;
  margin: 0 0 18px 0;
  font-weight: 700;
  
  @media (min-width: 768px) {
    font-size: 22px;
    margin: 0 0 20px 0;
  }
`;

const StepsImage = styled.img`
  width: 100%;
  display: block;
  border-radius: 16px;
`;

const StepsContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  border: none;
  
  @media (min-width: 768px) {
    padding: 24px 20px;
  }
`;

const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
  position: relative;
`;

const StepSeparator = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 20px 0 20px 40px;
  width: calc(100% - 40px);
`;

const StepItem1 = styled(StepItem)`
  &::before {
    content: '';
    position: absolute;
    left: 9px;
    top: 28px;
    width: 2px;
    height: calc(100% - 28px);
    background: #e5e7eb;
    z-index: 0;
  }
`;

const StepItem2 = styled(StepItem)`
  &::before {
    content: '';
    position: absolute;
    left: 9px;
    top: 24px;
    width: 2px;
    height: calc(100% - 24px);
    background: #e5e7eb;
    z-index: 0;
  }
`;

const StepItem3 = styled(StepItem)`
  &::before {
    content: '';
    position: absolute;
    left: 9px;
    top: 24px;
    width: 2px;
    height: calc(100% - 24px);
    background: #e5e7eb;
    z-index: 0;
  }
`;

const StepItem4 = styled(StepItem)``;

const StepNumber1 = styled.div`
  width: 20px;
  height: 20px;
  background: #6b46c1;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  margin-right: 12px;
  z-index: 1;
`;

const StepNumber2 = styled.div`
  color: #6b46c1;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  margin-right: 12px;
  z-index: 1;
  width: 20px;
  text-align: center;
`;

const StepNumber3 = styled(StepNumber2)``;
const StepNumber4 = styled(StepNumber2)``;

const StepIconContainer = styled.div`
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  
  @media (min-width: 768px) {
    width: 62px;
    height: 62px;
    margin-right: 14px;
  }
  
  img {
    width: 62px;
    height: 62px;
    object-fit: contain;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: optimize-contrast;
    
    @media (min-width: 768px) {
      width: 62px;
      height: 62px;
    }
  }
`;

const StepContent = styled.div`
  flex: 1;
  padding-top: 10px;
`;

const StepTitle = styled.div`
  color: #111827;
  font-size: 15px;
  margin: 0;
  line-height: 1.5;
  font-weight: 600;
  
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const ScanAndPayHomepage = (props) => {
  const [hospitalLogo, setHospitalLogo] = useState(null);
  const [hospitalId, setHospitalId] = useState(null);
  const [hexCode, setHexCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { location } = props;
    const params = new URLSearchParams(location.search);
    const hexCodeParam = params.get('hexCode') || '';
    if (hexCodeParam) {
      setHexCode(hexCodeParam);
    }

    fetchCenterLogos(hexCodeParam)
      .then((res) => {
        if (res && res.logos) {
          setHospitalLogo(res.logos.hospitalLogo || "");
          if (res.centerId) {
            setHospitalId(res.centerId);
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error('Error fetching center logos:', err);
        setLoading(false);
      });
  }, []);

  const handleBackPress = () => {
    const { history } = props;
    history.goBack();
  };

  const handleServiceClick = (serviceName) => {
    serviceName = 'consultation';
    if (serviceName === 'consultation') {
      const { history, loginState, authToken, landingPageData } = props;

      const headerCard = landingPageData?.headerCard;
      const hospitalName = headerCard?.header || null;
      const logoToUse = headerCard?.hospitalLogo || hospitalLogo;

      console.log('Navigating to consultation/start with flag');
      if (loginState === 'LOGGED_IN' && authToken) {
        history.push('/consultation/start', {
          card: 'pre-book-appointment',
          showOnlineAndOffline: false,
          isFromScanAndPay: true,
          hospitalId: hospitalId,
          hospitalName: hospitalName,
          hospitalLogo: logoToUse,
          hexCode: hexCode,
          isSelfBookScanAndPay: '1'
        });
      } else {
        let redirectUrl = '/login?rt=redirect?rt=offline-self-book';
        if (hospitalId) {
          redirectUrl += `%26hospitalId=${hospitalId}`;
        }
        if (hexCode) {
          redirectUrl += `%26hexCode=${hexCode}`;
        }
        history.push(redirectUrl);
      }
    }
  };

  const services = [
    {
      image: ClinicAppointments,
      name: 'Clinic Appointments',
      description: 'Book Consultation with Doctor',
      key: 'consultation'
    },
    // {
    //   image: LabTests,
    //   name: 'Lab Tests',
    //   description: 'Book Lab Tests & Diagnostics',
    //   key: 'lab-tests'
    // },
    // {
    //   image: Pharmcy,
    //   name: 'Pharmacy',
    //   description: 'Get your prescribed medicines',
    //   key: 'pharmacy'
    // },
  ];

  const steps = [
    { image: HospitalService, title: 'Select a service' },
    { image: EnterAppointmentDetails, title: 'Enter your appointment details' },
    { image: RecieveCashlessLetter, title: 'Receive your instant cashless letter' },
    { image: CompleteAppointment, title: 'Complete your appointment cash free!' },
  ];
  return (
    <Container>
      <Header>
        <HeaderContent>
          <WelcomeText>Welcome to</WelcomeText>
          {hospitalLogo && <LogoContainer>
            <LogoImage
              src={hospitalLogo}
              alt={"Hospital Logo"}
            />
          </LogoContainer>}
          <SubTitle>
            <span className="cashless">Cashless</span>
            <span className="powered-by">Powered by</span>
            <VisitLogoImage src={VisitLogo} alt="VISIT" />
          </SubTitle>
        </HeaderContent>
      </Header>

      <ContentSection>
        <SectionTitle>Our Services</SectionTitle>

        <ServiceCardsContainer>
          {services.map((service) => (
            <ServiceCard
              key={service.key}
              onClick={() => handleServiceClick(service.key)}
              isRectangular={service.key === 'pharmacy'}
            >
              <img src={service.image} alt={service.name} />
            </ServiceCard>
          ))}
        </ServiceCardsContainer>

        <HowItWorksSection>
          <HowItWorksTitle>How it Works</HowItWorksTitle>

          <StepsContainer>
            <StepItem1>
              <StepNumber1>1</StepNumber1>
              <StepIconContainer>
                <img src={HospitalService} alt="Select a service" />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Select a service</StepTitle>
              </StepContent>
            </StepItem1>

            <StepSeparator />

            <StepItem2>
              <StepNumber2>2</StepNumber2>
              <StepIconContainer>
                <img src={EnterAppointmentDetails} alt="Enter your appointment details" />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Enter your appointment details</StepTitle>
              </StepContent>
            </StepItem2>

            <StepSeparator />

            <StepItem3>
              <StepNumber3>3</StepNumber3>
              <StepIconContainer>
                <img src={RecieveCashlessLetter} alt="Receive your instant cashless letter" />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Receive your instant cashless letter</StepTitle>
              </StepContent>
            </StepItem3>

            <StepSeparator />

            <StepItem4>
              <StepNumber4>4</StepNumber4>
              <StepIconContainer>
                <img src={CompleteAppointment} alt="Complete your appointment cash free!" />
              </StepIconContainer>
              <StepContent>
                <StepTitle>Complete your appointment cash free!</StepTitle>
              </StepContent>
            </StepItem4>
          </StepsContainer>
        </HowItWorksSection>
      </ContentSection>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
});

export default connect(mapStateToProps)(ScanAndPayHomepage);
